<template>
	<div style="height: 100vh;">
		<div id="energy" class="page">
			<dv-full-screen-container class="bg">
				<dv-loading v-if="loading">Loading...</dv-loading>
				<div v-else class="host-body">
					<Navbar @logout="logout" :buildingSelect='buildingSelect' :navbarType='navbarType'
						:building='building' :buildingName='buildingName' @second="recordProgress" />
					<div class="body-box">
						<div class="energy-box d-flex">
							<div style="margin-left: 0.3rem;">
								<div>
									<energyLeftTop ref="energyLeftTop"
										@energySurveyFloorEnergy="energySurveyFloorEnergy(arguments)"
										:energyLeftTopData="energyLeftTopData" />
								</div>
								<div class="mt-3">
									<energyLeftBottom :energyLeftBottomData="energyLeftBottomData" />
								</div>
							</div>
							<div style="margin-left: 0.3rem;">
								<div>
									<energyRightTop :building='building' />
								</div>
								<div class="mt-3 energy-rightBox d-flex">
									<div>
										<energyRightBottom1 :building='building' />
									</div>
									<div style="margin-left: 0.45rem;">
										<energyRightBottom2 :building='building' />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</dv-full-screen-container>
		</div>
	</div>
</template>

<script>
	import Navbar from "../layout/Navbar";
	import energyLeftTop from "./energy/energyLeftTop";
	import energyLeftBottom from "./energy/energyLeftBottom";
	import energyRightTop from "./energy/energyRightTop";
	import energyRightBottom1 from "./energy/energyRightBottom1";
	import energyRightBottom2 from "./energy/energyRightBottom2";
	import Cookies from 'js-cookie';

	export default {
		data() {
			return {
				loading: true,
				currtime: "",
				energyLeftTopData: {},
				energyLeftBottomData: [],
				buildingSelect: [],
				buildingName: '',
				navbarType: true,
				building: ''
			};
		},
		components: {
			Navbar,
			energyLeftTop,
			energyLeftBottom,
			energyRightTop,
			energyRightBottom1,
			energyRightBottom2
		},
		watch: {
			'building': {
				handler() {
					this.energySurveyFloorEnergy(this.getNowTime());
				},
			}
		},
		mounted() {
			this.getBuilding();
			this.cancelLoading();
		},
		methods: {
			async getBuilding() {
				await this.$axios.get("/api/buildings").then(res => {
					let buildingSelect = []
					for (let item of res.data.data) {
						buildingSelect.push({
							label: item.abbreviation,
							value: String(item.id)
						})
					}
					this.buildingSelect = buildingSelect
					if (Cookies.get('building')) {
						this.building = Cookies.get('building')
						this.buildingName = Cookies.get('buildingName')
					} else {
						Cookies.set('building', buildingSelect[0].value)
						Cookies.set('buildingName', buildingSelect[0].label)
						this.building = buildingSelect[0].value
						this.buildingName = buildingSelect[0].label
					}
					this.energySurveyFloorEnergy(this.getNowTime());
				})
			},
			async energySurveyFloorEnergy(time) {
				let dataObj = {
					building_id: this.building,
					start_time: time[0],
					end_time: time[1],
				}
				await this.$axios.get("/api/buildings/energySurveyFloorEnergy", {
					params: dataObj
				}).then(res => {
					this.energyLeftTopData = res.data.data.device_type_energy
					this.energyLeftBottomData = res.data.data.floor_energy.sort(this.sortBy('value'))
				})
			},
			sortBy(i) {
				return function(a, b) {
					return b[i] - a[i]
				}
			},
			getNowTime() {
				var date = new Date();
				var seperator1 = "-";
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var strDate = date.getDate() - 1;
				var endDate = date.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				if (endDate >= 0 && endDate <= 9) {
					endDate = "0" + endDate;
				}
				var currentdate = year + seperator1 + month + seperator1 + strDate;
				var enddate = year + seperator1 + month + seperator1 + endDate;
				// console.log(currentdate)
				return [currentdate, enddate];
			},
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
				}, 1000);
			},
			logout() {
				this.$axios.post("/api/logout").then(res => {
					if (process.env.NODE_ENV === "production") {
						Cookies.remove('token', {
							domain: "hzng-iot.com"
						});
					} else {
						Cookies.set('token', '', -1)
					}
					this.$router.replace("/login");
				})
			},
			recordProgress: function(val) { //val用于接收子组件传过来的值
				this.building = val[0]
				this.buildingName = val[1]
			},
		},
	};
</script>

<style lang="scss">
	@import "../assets/scss/index.scss";
</style>
